export default {
  close: {
    en: 'Close dialog',
  },
}
